<section class="settings-page">
    <div class="settings-shell">
        <aside class="settings-sidebar">
            <div class="settings-user">
                <div class="settings-user__avatar">
                    <img
                        [src]="userImg || './assets/img/icon_red.png'"
                        (error)="setDefaultAvatar($event)"
                        alt="Foto de perfil"
                    >
                </div>
                <div>
                    <span>Mi cuenta</span>
                    <h2>{{ user.first_name }} {{ user.last_name }}</h2>
                </div>
            </div>

            <nav class="settings-nav" aria-label="Opciones de ajustes">
                <a
                    class="settings-nav__item"
                    routerLinkActive="active-link"
                    (click)="changeTitle('Editar perfil')"
                    [routerLink]="['/panel/settings/edit-profile']"
                >
                    <mat-icon>manage_accounts</mat-icon>
                    <span>Editar perfil</span>
                </a>

                <button
                    type="button"
                    class="settings-nav__item settings-nav__item--button"
                    (click)="changeTitle('Términos y condiciones'); openTerms()"
                >
                    <mat-icon>description</mat-icon>
                    <span>Términos y condiciones</span>
                </button>
            </nav>
        </aside>

        <main class="settings-content">
            <header class="settings-content__header">
                <span>Mindhelp</span>
                <h1>{{ title }}</h1>
            </header>
            <section class="settings-content__body">
                <router-outlet></router-outlet>
            </section>
        </main>
    </div>
</section>
